/**
 * Einkaufsliste aus dem Wochenplan (F-35 A) - rein und getestet. Rezepte
 * werden in ihre Zutaten aufgeloest (nach Portionen), gleiche Lebensmittel
 * zusammengezaehlt, sortiert nach Supermarkt-Abteilung.
 */
import { GRUPPEN, type PlanTag } from '@/domain/ernaehrung/typen';
import type { Daten } from '@/domain/ernaehrung/naehrwerte';
import type { ID } from '@/domain/types';

/** `abteilung` fehlt ohne Lebensmittelgruppe - dann ordnet die Liste selbst ein (F-33). */
export interface EinkaufsPosten { lebensmittelId: ID; name: string; menge: number; basis: 'g' | 'ml'; abteilung?: string; text: string }

export function mengeLesbar(menge: number, basis: 'g' | 'ml'): string {
  if (menge >= 1000) return `${(Math.round(menge / 100) / 10).toLocaleString('de-DE')} ${basis === 'g' ? 'kg' : 'l'}`;
  return `${Math.round(menge)} ${basis}`;
}

export function einkaufsliste(tage: PlanTag[], d: Daten): EinkaufsPosten[] {
  const summe = new Map<ID, number>();
  const plus = (id: ID, m: number) => summe.set(id, (summe.get(id) ?? 0) + m);
  for (const t of tage) for (const mz of t.mahlzeiten) for (const p of mz.posten) {
    if (p.art === 'lebensmittel') plus(p.refId, p.menge);
    if (p.art === 'rezept') {
      const r = d.rezepte.get(p.refId);
      if (!r) continue;
      for (const z of r.zutaten) plus(z.lebensmittelId, (z.menge * p.menge) / Math.max(1, r.portionen));
    }
  }
  const out: EinkaufsPosten[] = [];
  for (const [id, menge] of summe) {
    const l = d.lebensmittel.get(id);
    if (!l || menge <= 0) continue;
    out.push({ lebensmittelId: id, name: l.name, menge, basis: l.basis, abteilung: l.gruppe ? GRUPPEN[l.gruppe].abteilung : undefined, text: mengeLesbar(menge, l.basis) });
  }
  return out.sort((a, b) => (a.abteilung ?? '~').localeCompare(b.abteilung ?? '~', 'de') || a.name.localeCompare(b.name, 'de'));
}
